import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "@reduxjs/toolkit";
import SelectInputElementComponent from "../../general/elements/inputElements/SelectInputElementComponent";
import AlertService from "../../../services/alerts/alert.service";
import accountActions from "../../../store/actions/accounts/account.actions";
import businessCustomerActions from "../../../store/actions/businessCustomer/businessCustomer.actions";
import validationHelper from "../../../helpers/validation.helper";
import AccountErrorsEnum from "../../../enums/errors/accounts/accountErrors.enum";

import "../../../styles/components/dialogs/accounts/addOrUpdateBusinessAccountsDialogComponent.scss";
import textInputModel from "../../../models/general/elements/inputElements/textInput.model";
import TextInputElementComponent from "../../general/elements/inputElements/TextInputElementComponent";

const AddOrUpdateBusinessAccountsDialogComponent = ({ accountActions, businessCustomerActions, businessCustomers, accounts }) => {
  const [credentails, setCredentails] = useState({
    email: "",
    password: "",
    businessCustomerId: "",
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    fetchBusinessCustomers();
  }, []);

  const fetchBusinessCustomers = async () => {
    try {
      await businessCustomerActions.fetchBusinessCustomers();
    } catch (error) {
      console.error("Error fetching business customers:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentails({ ...credentails, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!validationHelper.validateEmail(credentails.email)) {
      newErrors.email = "כתובת דואר אלקטרוני לא תקינה";
    }
    if (!validationHelper.validatePassword(credentails.password)) {
      newErrors.password = "הסיסמה לא תקינה, על הסיסמה להיות לפחות 6 תווים";
    }
    if (!credentails.businessCustomerId) {
      newErrors.businessCustomerId = "יש לבחור לקוח עסקי";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const getRegisterErrorMessage = (errorCode) => {
    switch (errorCode) {
      case AccountErrorsEnum.EmailAlreadyExists:
        return "כתובת הדואר האלקטרוני כבר קיימת";
      case AccountErrorsEnum.BusinessCustomerNotFound:
        return "לקוח עסקי לא נמצא";
      default:
        return "שגיאה לא ידועה";
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validateForm()) return;

    try {
      const response = await accountActions.registerBusiness(credentails);
      if (!validationHelper.validateHttpResponse(response, true)) {
        setErrors({ general: getRegisterErrorMessage(response?.error?.code) });
        return;
      }

      AlertService.success("החשבון העסקי נוצר בהצלחה");
      setCredentails({ email: "", password: "", businessCustomerId: "" });
    } catch (error) {
      AlertService.error("חלה שגיאה ביצירת החשבון העסקי");
      console.error("Error creating business account:", error);
    }
  };

  const getBusinessCustomerSelectElement = () => {
    const registeredCustomerIds = new Set(accounts?.map((account) => account.businessCustomer?.customerId));

    const options = businessCustomers
      .map((customer) => ({
        value: customer.customerId,
        label: `${customer.lastName} - ${customer.customerId}`,
      }));

    const inputProps = {
      name: "businessCustomerId",
      label: "לקוחות עסקיים",
      value: credentails.businessCustomerId,
      options,
      onChange: handleInputChange,
      searchable: true, // Enable search
    };

    return <SelectInputElementComponent props={inputProps} />;
  };

  const getEmailInputElement = () => {
    const inputProps = {
      ...textInputModel,
      name: "email",
      type: "email",
      error: errors.email,
      value: credentails.email,
      placeholder: "הכנס דואר אלקטרוני",
      onChange: handleInputChange,
    };
    return <TextInputElementComponent props={inputProps} />;
  };

  const getPasswordInputElement = () => {
    const inputProps = {
      ...textInputModel,
      name: "password",
      type: "password",
      error: errors.password,
      value: credentails.password,
      placeholder: "הכנס סיסמה",
      onChange: handleInputChange,
    };
    return <TextInputElementComponent props={inputProps} />;
  };

  return (
    <div className="dialogContainer addOrUpdateBusinessAccountsDialogContainer">
      <h2>יצירה או עדכון חשבון עסקי</h2>
      <form onSubmit={handleSubmit}>
        {getEmailInputElement()}
        {getPasswordInputElement()}

        <div className="formGroup">{getBusinessCustomerSelectElement()}</div>
        {errors.businessCustomerId && <span className="error">{errors.businessCustomerId}</span>}

        <button type="submit" className="primaryButton">
          שמור
        </button>
        {errors.general && <span className="error">{errors.general}</span>}
      </form>
    </div>
  );
};

const mapStateToProps = (state) => ({
  businessCustomers: state.businessCustomerReducer?.businessCustomers,
  accounts: state.accountReducer.usersByBusiness,
});

const mapDispatchToProps = (dispatch) => {
  return {
    accountActions: bindActionCreators(accountActions, dispatch),
    businessCustomerActions: bindActionCreators(businessCustomerActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddOrUpdateBusinessAccountsDialogComponent);
